import { HttpClient, HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { NotificationService } from '@core/services/notification';
import { config } from '@env/config';
import { BehaviorSubject, catchError, filter, Observable, switchMap, take, tap, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private baseUrl = config.apiUrl;
  private isRefreshing = false;
  private refreshSubject = new BehaviorSubject<any>(null);
  constructor(
    private http: HttpClient,
    private router: Router,
    private notificationService: NotificationService
  ) { }

  login(email: string, password: string, active_state?: string): Observable<any> {
    const payload: any = { email, password };
    if (active_state) payload.active_state = active_state;

    return this.http.post(`${this.baseUrl}/login/`, payload);
  }
  refreshToken(): Observable<any> {
    const refresh = this.getRefreshToken();
    if (!refresh) return throwError(() => new Error('No refresh token available'));

    return this.http.post(`${this.baseUrl}/token/refresh/`, { refresh }).pipe(
      tap((response: any) => {
        // Use new refresh token if provided, otherwise keep the old one
        const newRefresh = response.refresh || refresh;
        this.saveTokens(response.access, newRefresh);
      })
    );
  }

  saveTokens(access: string, refresh: any) {
    localStorage.setItem('access_token', access);
    localStorage.setItem('refresh_token', refresh);
  }

  getAccessToken() {
    return localStorage.getItem('access_token');
  }

  getRefreshToken() {
    return localStorage.getItem('refresh_token');
  }

  logout() {
    localStorage.clear();
    this.router.navigate(['/auth/login/step0']);
  }

  // Handle refresh token logic used by interceptor
  handle401Error(req: HttpRequest<any>, next: HttpHandlerFn): Observable<HttpEvent<any>> {
    if (!this.isRefreshing) {
      this.isRefreshing = true;
      this.refreshSubject.next(null);

      return this.refreshToken().pipe(
        switchMap((token: any) => {
          this.isRefreshing = false;
          this.refreshSubject.next(token.access);
          const newReq = req.clone({
            setHeaders: { Authorization: `Bearer ${token.access}` }
          });
          return next(newReq);
        }),
        catchError((err) => {
          this.isRefreshing = false;
          // Signal error to all waiting requests
          this.refreshSubject.error(err);
          // Re-create subject for future usage as error() completes it
          this.refreshSubject = new BehaviorSubject<any>(null);
          
          this.logout();
          this.notificationService.showError('Session expired. Please login again.');
          return throwError(() => err);
        })
      );
    } else {
      return this.refreshSubject.pipe(
        filter(token => token != null),
        take(1),
        switchMap((token: string) => {
          const newReq = req.clone({
            setHeaders: { Authorization: `Bearer ${token}` }
          });
          return next(newReq);
        }),
        catchError((err) => {
          // If the primary refresh failed, these waiting requests should also fail
          return throwError(() => err);
        })
      );
    }
  }

  // // Login
  // login(data: any): Observable<any>{
  //   return this.http.post(`${this.baseUrl}/login/`, data);
  // }

  // // Refresh Token
  // refreshToken(refresh: string) {
  //   return this.http.post(`${this.baseUrl}/token/refresh/`, { refresh });
  // }

  // // Save tokens in localStorage
  // saveTokens(access: string, refresh: string) {
  //   localStorage.setItem('access_token', access);
  //   localStorage.setItem('refresh_token', refresh);
  // }

  // // Get token
  // getAccessToken() {
  //   return localStorage.getItem('access');
  // }

  // // Remove tokens (logout)
  // logout() {
  //   localStorage.removeItem('access');
  //   localStorage.removeItem('refresh');
  //   this.router.navigate(['/login']);
  // }

  // Check if logged in
  isLoggedIn(): boolean {
    const token = localStorage.getItem('access_token');
    if (!token) return false;
    
    // Optional: Add JWT expiration check here if a library like jwt-decode is added
    // For now, presence of token is our best guest until an API call fails
    return true;
  }

  //  registerUser(data: any): Observable<any> {
  //   return this.http.post(`${this.baseUrl}/register/`, data);
  // }

  // sendOtp(phone: string): Observable<any> {
  //   return this.http.post(`${this.baseUrl}/verification/phone/send-otp/`, { phone });
  // }

  // verifyOtp(phone: string, otp: string): Observable<any> {
  //   return this.http.post(`${this.baseUrl}/verification/phone/verify-otp/`, { phone, otp });
  // }

  // getSectors(): Observable<any> {
  //   return this.http.get(`${this.baseUrl}/organizations/`);
  // }

  // submitSectorData(data: any): Observable<any> {
  //   return this.http.post(`${this.baseUrl}/organizations/`, data);
  // }
}
